(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adv-promo-offer-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function secondsUntilNextMidnight() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      return Math.max(0, Math.floor((end.getTime() - now.getTime()) / 1000));
    }

    function bindTimer(root) {
      if (!root || root.dataset.apoTimerInit === '1') return;
      var el = root.querySelector('[data-apo-timer]');
      if (!el) return;
      root.dataset.apoTimerInit = '1';

      function tick() {
        var sec = secondsUntilNextMidnight();
        var h = Math.floor(sec / 3600);
        sec -= h * 3600;
        var m = Math.floor(sec / 60);
        var s = sec - m * 60;
        el.textContent = pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
      }

      tick();
      var id = window.setInterval(tick, 1000);
      root._apoTimerId = id;
    }

    function unbindTimer(root) {
      if (!root) return;
      if (root._apoTimerId) {
        window.clearInterval(root._apoTimerId);
        root._apoTimerId = null;
      }
      delete root.dataset.apoTimerInit;
    }

    function initAll() {
      document.querySelectorAll('.adv-promo-offer-v2').forEach(bindTimer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function onDom() {
        document.removeEventListener('DOMContentLoaded', onDom);
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      var target = ev.target;
      if (!target || !target.querySelector) return;
      var el = target.classList.contains('adv-promo-offer-v2')
        ? target
        : target.querySelector('.adv-promo-offer-v2');
      if (el) {
        unbindTimer(el);
        setTimeout(function () {
          bindTimer(el);
        }, 0);
      }
    });

    document.addEventListener('shopify:section:unload', function (ev) {
      var target = ev.target;
      if (!target || !target.querySelector) return;
      var el = target.classList.contains('adv-promo-offer-v2')
        ? target
        : target.querySelector('.adv-promo-offer-v2');
      if (el) unbindTimer(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evamats-article-kariera-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(min-width: 990px)');
    var END_GAP = 40;
    var roots = document.querySelectorAll(
      '.evamats-article-kariera-hero__aside[data-kariera-sticky-aside]'
    );
    if (!roots.length) return;

    function topOffset() {
      var headerH =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        ) || 0;
      return headerH + 24;
    }

    function clearCard(card) {
      card.classList.remove('is-sticky-fixed');
      card.style.top = '';
      card.style.left = '';
      card.style.width = '';
    }

    function resetAside(aside, card) {
      clearCard(card);
    }

    function readAnchorTop(aside) {
      return aside.getBoundingClientRect().top + window.scrollY;
    }

    function updateAside(aside) {
      var card = aside.querySelector('.evamats-article-kariera-hero__aside-card');
      if (!card) return;

      if (!mq.matches) {
        resetAside(aside, card);
        return;
      }

      var stop = document.querySelector('.evamats-kariera-benefits');
      if (!stop) {
        resetAside(aside, card);
        return;
      }

      var headerTop = topOffset();
      var scrollY = window.scrollY;
      var cardH = card.offsetHeight;
      var asideRect = aside.getBoundingClientRect();
      var stopRect = stop.getBoundingClientRect();

      if (!card.classList.contains('is-sticky-fixed')) {
        aside.dataset.anchorTop = String(readAnchorTop(aside));
      }

      var anchorTop = parseFloat(aside.dataset.anchorTop);
      if (!Number.isFinite(anchorTop)) {
        clearCard(card);
        return;
      }

      var fixStart = anchorTop - headerTop;
      var stopViewportTop = stopRect.top - END_GAP - cardH;

      if (scrollY < fixStart) {
        clearCard(card);
        aside.dataset.anchorTop = String(readAnchorTop(aside));
        return;
      }

      var fixedTop = Math.min(headerTop, stopViewportTop);

      card.classList.add('is-sticky-fixed');
      card.style.top = fixedTop + 'px';
      card.style.left = asideRect.left + 'px';
      card.style.width = asideRect.width + 'px';
    }

    function remeasureAll() {
      roots.forEach(function (aside) {
        var card = aside.querySelector('.evamats-article-kariera-hero__aside-card');
        if (!card) return;
        clearCard(card);
        updateAside(aside);
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        roots.forEach(updateAside);
      });
    }

    roots.forEach(function (aside) {
      updateAside(aside);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasureAll);
    window.addEventListener('load', remeasureAll);
    mq.addEventListener('change', remeasureAll);

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(remeasureAll);
      roots.forEach(function (aside) {
        ro.observe(aside);
      });
      var stop = document.querySelector('.evamats-kariera-benefits');
      if (stop) ro.observe(stop);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o-nas-founder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function destroyFounder(root) {
      if (!root) return;
      if (root._ofSwiper) {
        try {
          root._ofSwiper.destroy(true, true);
        } catch (e) {}
        root._ofSwiper = null;
      }
      delete root.dataset.ofSwiperInit;
    }

    var founderVideoConfig = {
      videoAttr: 'data-of-video',
      mq: '(min-width: 1024px)',
      statePrefix: 'ofVideo',
      initDatasetKey: 'ofVideoInit',
    };

    function destroyFounderVideo(root) {
      if (typeof window.evamatsDestroyLazyScrollVideo === 'function') {
        window.evamatsDestroyLazyScrollVideo(root, founderVideoConfig);
      }
    }

    function initFounderVideo(root) {
      if (!root || typeof window.evamatsInitLazyScrollVideo !== 'function') return;
      window.evamatsInitLazyScrollVideo(
        Object.assign(
          {
            root: root,
            section: root.closest('section.o-nas-founder') || root,
            visibilityTarget: root,
          },
          founderVideoConfig
        )
      );
    }

    function initFounder(root) {
      if (!root || root.dataset.ofSwiperInit === '1') return;
      var swiperEl = root.querySelector('[data-of-swiper]');
      if (!swiperEl) return;
      var slides = swiperEl.querySelectorAll('.swiper-slide');
      var count = slides.length;
      if (!count) return;

      var paginationEl = root.querySelector('[data-of-pagination]');

      function run() {
        if (typeof window.Swiper === 'undefined') return;
        if (root.dataset.ofSwiperInit === '1') return;
        root.dataset.ofSwiperInit = '1';

        var opts = {
          speed: 450,
          watchOverflow: true,
          breakpoints: {
            0: {
              slidesPerView: 1,
              centeredSlides: false,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 1,
              centeredSlides: false,
              spaceBetween: 0,
            },
          },
        };

        if (count > 1) {
          opts.loop = true;
        }

        if (paginationEl && count > 1) {
          opts.pagination = { el: paginationEl, clickable: true };
        }

        root._ofSwiper = new window.Swiper(swiperEl, opts);
      }

      function whenSwiperReady(cb) {
        if (typeof window.Swiper !== 'undefined') {
          cb();
          return;
        }
        if (typeof window.ensureSwiperLoaded === 'function') {
          window.ensureSwiperLoaded(cb);
          return;
        }
        var done = false;
        var poll = null;
        function finish() {
          if (done) return;
          if (typeof window.Swiper === 'undefined') return;
          done = true;
          document.removeEventListener('swiper-loaded', onLoaded);
          if (poll) clearInterval(poll);
          cb();
        }
        function onLoaded() {
          finish();
        }
        document.addEventListener('swiper-loaded', onLoaded);
        poll = setInterval(finish, 50);
        setTimeout(function () {
          if (poll) clearInterval(poll);
          document.removeEventListener('swiper-loaded', onLoaded);
        }, 8000);
      }

      whenSwiperReady(run);
    }

    function initAll() {
      document.querySelectorAll('[data-of-root]').forEach(initFounder);
      document.querySelectorAll('[data-of-video-root]').forEach(initFounderVideo);
    }

    function scheduleInit() {
      function go() {
        initAll();
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function onDom() {
          document.removeEventListener('DOMContentLoaded', onDom);
          setTimeout(go, 0);
        });
      } else {
        setTimeout(go, 0);
      }
    }

    scheduleInit();
    document.addEventListener('swiper-loaded', initAll);

    document.addEventListener('shopify:section:load', function (ev) {
      var target = ev.target;
      if (!target || !target.querySelector) return;
      var sliderRoot = target.querySelector('[data-of-root]');
      if (sliderRoot) {
        destroyFounder(sliderRoot);
        setTimeout(function () {
          initFounder(sliderRoot);
        }, 0);
      }
      var videoRoot = target.querySelector('[data-of-video-root]');
      if (videoRoot) {
        destroyFounderVideo(videoRoot);
        setTimeout(function () {
          initFounderVideo(videoRoot);
        }, 0);
      }
    });

    document.addEventListener('shopify:section:unload', function (ev) {
      var target = ev.target;
      if (!target || !target.querySelector) return;
      var sliderRoot = target.querySelector('[data-of-root]');
      if (sliderRoot) destroyFounder(sliderRoot);
      var videoRoot = target.querySelector('[data-of-video-root]');
      if (videoRoot) destroyFounderVideo(videoRoot);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o-nas-story-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function destroyStory(section) {
      if (!section) return;
      if (section._onsResizeTimer) {
        try {
          clearTimeout(section._onsResizeTimer);
        } catch (e) {}
        section._onsResizeTimer = null;
      }
      if (section._onsRo) {
        try {
          section._onsRo.disconnect();
        } catch (e) {}
        section._onsRo = null;
      }
      if (section._onsOnWinResize) {
        try {
          window.removeEventListener('resize', section._onsOnWinResize);
        } catch (e) {}
        section._onsOnWinResize = null;
      }
      if (section._onsCard) {
        try {
          section._onsCard.destroy(true, true);
        } catch (e) {}
        section._onsCard = null;
      }
      if (section._onsBg) {
        try {
          section._onsBg.destroy(true, true);
        } catch (e) {}
        section._onsBg = null;
      }
      var videoRoot = section.querySelector('[data-ons-video-root]');
      if (videoRoot) {
        destroyStoryVideo(videoRoot);
      }
      delete section.dataset.onsSwiperInit;
    }

    var storyVideoConfig = {
      videoAttr: 'data-ons-video',
      mq: '(min-width: 750px)',
      statePrefix: 'onsVideo',
      initDatasetKey: 'onsVideoInit',
    };

    function destroyStoryVideo(root) {
      if (typeof window.evamatsDestroyLazyScrollVideo === 'function') {
        window.evamatsDestroyLazyScrollVideo(root, storyVideoConfig);
      }
    }

    function initStoryVideo(section) {
      var root = section && section.querySelector('[data-ons-video-root]');
      if (!root || typeof window.evamatsInitLazyScrollVideo !== 'function') return;
      window.evamatsInitLazyScrollVideo(
        Object.assign(
          {
            root: root,
            section: section,
            visibilityTarget: root,
          },
          storyVideoConfig
        )
      );
    }

    function initStory(section) {
      if (!section || section.dataset.onsSwiperInit === '1') return;
      if (section.dataset.onsBgMode === 'video') {
        initStoryVideo(section);
      }
      var bgMode = section.dataset.onsBgMode || 'carousel';
      var bgEl = section.querySelector('[data-ons-bg-swiper]');
      var cardEl = section.querySelector('[data-ons-card-swiper]');
      if (!cardEl) return;
      if (bgMode === 'carousel' && !bgEl) return;
      var slides = cardEl.querySelectorAll('.swiper-slide');
      var count = slides.length;
      if (!count) return;

      var paginationEl = section.querySelector('[data-ons-pagination]');
      var prevEl = section.querySelector('.eva-slider-nav--prev');
      var nextEl = section.querySelector('.eva-slider-nav--next');

      function run() {
        if (typeof window.Swiper === 'undefined') return;
        if (section.dataset.onsSwiperInit === '1') return;
        section.dataset.onsSwiperInit = '1';

        var baseOpts = {
          speed: 520,
          watchOverflow: true,
          slidesPerView: 1,
          spaceBetween: 0,
          allowTouchMove: true,
        };

        if (count > 1) {
          baseOpts.loop = true;
        }

        var bgOpts = Object.assign({}, baseOpts, {
          observer: true,
          observeParents: true,
          effect: 'fade',
          fadeEffect: { crossFade: true },
        });

        var cardOpts = Object.assign({}, baseOpts, {
          effect: 'fade',
          fadeEffect: { crossFade: true },
          autoHeight: true,
        });

        if (paginationEl && count > 1) {
          cardOpts.pagination = { el: paginationEl, clickable: true };
        }
        if (prevEl && nextEl && count > 1) {
          cardOpts.navigation = { prevEl: prevEl, nextEl: nextEl };
        }

        var bgSwiper = null;
        if (bgMode === 'carousel' && bgEl) {
          bgSwiper = new window.Swiper(bgEl, bgOpts);
        }
        var cardSwiper = new window.Swiper(cardEl, cardOpts);

        function refreshCardHeight() {
          if (section._onsRefreshingHeight) return;
          section._onsRefreshingHeight = true;
          try {
            var beforeHeight = cardEl.offsetHeight;
            if (typeof cardSwiper.updateAutoHeight === 'function') {
              cardSwiper.updateAutoHeight(0);
            }
            cardSwiper.update();
            if (Math.abs(cardEl.offsetHeight - beforeHeight) < 1) return;
          } catch (eH) {}
          finally {
            section._onsRefreshingHeight = false;
          }
        }

        cardSwiper.on('slideChange', refreshCardHeight);

        var logoImg = section.querySelector('.o-nas-story__logo-img');
        if (logoImg) {
          if (logoImg.complete) {
            refreshCardHeight();
          } else {
            logoImg.addEventListener('load', refreshCardHeight, { once: true });
          }
        }

        function refreshStorySwipers() {
          if (bgSwiper) {
            try {
              bgSwiper.update();
            } catch (e1) {}
          }
          refreshCardHeight();
        }

        function scheduleStoryRefresh() {
          if (section._onsResizeTimer) {
            try {
              clearTimeout(section._onsResizeTimer);
            } catch (e) {}
          }
          section._onsResizeTimer = setTimeout(function () {
            section._onsResizeTimer = null;
            refreshStorySwipers();
          }, 80);
        }

        [0, 120, 400].forEach(function (delay) {
          setTimeout(refreshStorySwipers, delay);
        });

        section._onsOnWinResize = scheduleStoryRefresh;
        window.addEventListener('resize', section._onsOnWinResize);

        var syncLock = false;
        function indexOf(sw) {
          if (sw.params.loop && typeof sw.realIndex === 'number') return sw.realIndex;
          return sw.activeIndex;
        }
        function syncPair(from, to) {
          from.on('slideChange', function () {
            if (syncLock) return;
            var i = indexOf(from);
            var j = indexOf(to);
            if (i === j) return;
            var animSpeed = typeof from.params.speed === 'number' ? from.params.speed : 520;
            syncLock = true;
            try {
              if (to.params.loop && typeof to.slideToLoop === 'function') {
                to.slideToLoop(i, animSpeed, false);
              } else {
                to.slideTo(i, animSpeed, false);
              }
            } catch (err) {}
            window.requestAnimationFrame(function () {
              syncLock = false;
            });
          });
        }
        if (bgSwiper) {
          syncPair(cardSwiper, bgSwiper);
          syncPair(bgSwiper, cardSwiper);
          section._onsBg = bgSwiper;
        } else {
          section._onsBg = null;
        }

        section._onsCard = cardSwiper;
      }

      function whenSwiperReady(cb) {
        if (typeof window.Swiper !== 'undefined') {
          cb();
          return;
        }
        if (typeof window.ensureSwiperLoaded === 'function') {
          window.ensureSwiperLoaded(cb);
          return;
        }
        var done = false;
        var poll = null;
        function finish() {
          if (done) return;
          if (typeof window.Swiper === 'undefined') return;
          done = true;
          document.removeEventListener('swiper-loaded', onLoaded);
          if (poll) clearInterval(poll);
          cb();
        }
        function onLoaded() {
          finish();
        }
        document.addEventListener('swiper-loaded', onLoaded);
        poll = setInterval(finish, 50);
        setTimeout(function () {
          if (poll) clearInterval(poll);
          document.removeEventListener('swiper-loaded', onLoaded);
        }, 8000);
      }

      whenSwiperReady(run);
    }

    function initAllStory() {
      document.querySelectorAll('[data-ons-story-root].o-nas-story').forEach(function (section) {
        if (section.dataset.onsBgMode === 'video') {
          initStoryVideo(section);
        }
        initStory(section);
      });
    }

    function scheduleInit() {
      function go() {
        initAllStory();
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function onDom() {
          document.removeEventListener('DOMContentLoaded', onDom);
          setTimeout(go, 0);
        });
      } else {
        setTimeout(go, 0);
      }
    }

    scheduleInit();
    document.addEventListener('swiper-loaded', initAllStory);

    function findStorySection(el) {
      if (!el || !el.closest) return null;
      if (el.matches && el.matches('section.o-nas-story[data-ons-story-root]')) return el;
      return el.querySelector('section.o-nas-story[data-ons-story-root]');
    }

    document.addEventListener('shopify:section:load', function (ev) {
      var sec = findStorySection(ev.target);
      if (sec) {
        destroyStory(sec);
        setTimeout(function () {
          initStory(sec);
        }, 0);
      }
    });

    document.addEventListener('shopify:section:unload', function (ev) {
      var sec = findStorySection(ev.target);
      if (sec) destroyStory(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-spotlight-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPartnersComparison(root) {
      if (!root || root.dataset.partnersComparisonInit === '1') return;
      var block = root.querySelector('.comparison__block');
      if (!block) return;

      root.dataset.partnersComparisonInit = '1';

      var divisor = block.querySelector('.comparison__before');
      var slider = block.querySelector('.comparison__range');
      if (!divisor || !slider) return;

      var isInteracted = false;
      var progress = 0.5;
      var direction = 1;
      var animationFrame = null;
      var lastTime = performance.now();
      var speed = 0.0004;

      var easeInOut = function (t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      };

      var isElementInViewport = function (el) {
        var rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      };

      var beforeImg = divisor.querySelector('.comparison__before-media img');

      var syncBeforeImageWidth = function () {
        if (!beforeImg) return;
        beforeImg.style.width = block.offsetWidth + 'px';
      };

      var moveDivisor = function () {
        divisor.style.width = slider.value + '%';
        syncBeforeImageWidth();
      };

      var animateSlider = function (timestamp) {
        if (isInteracted || !isElementInViewport(block)) {
          if (animationFrame) cancelAnimationFrame(animationFrame);
          animationFrame = null;
          return;
        }
        var deltaTime = timestamp - lastTime;
        lastTime = timestamp;
        progress += speed * deltaTime * direction;
        if (progress >= 1) {
          progress = 1;
          direction = -1;
        } else if (progress <= 0) {
          progress = 0;
          direction = 1;
        }
        slider.value = 10 + easeInOut(progress) * 80;
        moveDivisor();
        animationFrame = requestAnimationFrame(animateSlider);
      };

      slider.addEventListener('input', function () {
        isInteracted = true;
        moveDivisor();
        if (animationFrame) cancelAnimationFrame(animationFrame);
      });

      var resume = function () {
        isInteracted = false;
        lastTime = performance.now();
        animateSlider(lastTime);
      };

      slider.addEventListener('mouseup', resume);
      slider.addEventListener('touchend', resume);
      slider.addEventListener('touchstart', function () {
        isInteracted = true;
        if (animationFrame) cancelAnimationFrame(animationFrame);
      });

      window.addEventListener(
        'scroll',
        function () {
          if (!isInteracted && isElementInViewport(block) && !animationFrame) {
            lastTime = performance.now();
            animateSlider(lastTime);
          }
        },
        { passive: true }
      );

      var onResize = function () {
        syncBeforeImageWidth();
        moveDivisor();
      };

      window.addEventListener('resize', onResize);
      moveDivisor();
      animateSlider(lastTime);
    }

    function boot() {
      document.querySelectorAll('.partners-spotlight-v2 [data-partners-comparison]').forEach(initPartnersComparison);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      var target = ev.target;
      if (!target || !target.querySelector) return;
      var section = target.classList.contains('partners-spotlight-v2')
        ? target
        : target.querySelector('.partners-spotlight-v2');
      if (!section) return;
      var comparison = section.querySelector('[data-partners-comparison]');
      if (comparison) {
        delete comparison.dataset.partnersComparisonInit;
        initPartnersComparison(comparison);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function destroySpotlight(root) {
      if (!root) return;
      if (root._psSwiper) {
        try {
          root._psSwiper.destroy(true, true);
        } catch (e) {}
        root._psSwiper = null;
      }
      if (root._psVideoIO) {
        try {
          root._psVideoIO.disconnect();
        } catch (e) {}
        root._psVideoIO = null;
      }
      if (root._psVideoMq) {
        var mqDestroy = root._psVideoMq;
        if (mqDestroy.removeEventListener) {
          mqDestroy.removeEventListener('change', root._psVideoMqHandler);
        } else if (mqDestroy.removeListener) {
          mqDestroy.removeListener(root._psVideoMqHandler);
        }
        root._psVideoMq = null;
        root._psVideoMqHandler = null;
      }
      root.querySelectorAll('[data-ps-video]').forEach(function (video) {
        video.pause();
        video.removeAttribute('src');
        try {
          video.load();
        } catch (e) {}
      });
      delete root.dataset.psVideoInit;
      delete root.dataset.psSwiperInit;
    }

    function initSpotlightVideo(root) {
      if (!root || root.dataset.psVideoInit === '1') return;
      var videoRoot = root.querySelector('[data-ps-video-root]');
      if (!videoRoot) return;
      var desktopEl = videoRoot.querySelector('[data-ps-video="desktop"]');
      var mobileEl = videoRoot.querySelector('[data-ps-video="mobile"]');
      if (!desktopEl && !mobileEl) return;

      root.dataset.psVideoInit = '1';
      var isInView = false;

      if (typeof window.evamatsBindVideoFullscreen === 'function') {
        window.evamatsBindVideoFullscreen(root);
      }

      function activeVideo() {
        var isDesktop = window.matchMedia('(min-width: 990px)').matches;
        if (isDesktop) return desktopEl || mobileEl;
        return mobileEl || desktopEl;
      }

      function pauseAll() {
        [desktopEl, mobileEl].forEach(function (video) {
          if (video && !video.paused) video.pause();
        });
      }

      function playVideo(video) {
        if (!video) return;
        var tryPlay = function () {
          if (!isInView && !(typeof Shopify !== 'undefined' && Shopify.designMode)) return;
          var playPromise = video.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(function () {});
          }
        };
        if (!video.src) {
          var src = video.getAttribute('data-src');
          if (!src) return;
          video.src = src;
          if (video.readyState >= 2) {
            tryPlay();
          } else {
            video.addEventListener('loadeddata', tryPlay, { once: true });
            video.addEventListener('canplay', tryPlay, { once: true });
          }
          return;
        }
        if (video.paused) tryPlay();
      }

      function playActive() {
        var active = activeVideo();
        if (!active) return;
        pauseAll();
        playVideo(active);
      }

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        isInView = true;
        playActive();
        return;
      }

      root._psVideoIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            isInView = entry.isIntersecting;
            if (isInView) {
              playActive();
            } else {
              pauseAll();
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px 80px 0px' }
      );
      root._psVideoIO.observe(root);

      var mq = window.matchMedia('(min-width: 990px)');
      root._psVideoMq = mq;
      root._psVideoMqHandler = function () {
        if (!isInView) return;
        playActive();
      };
      if (mq.addEventListener) {
        mq.addEventListener('change', root._psVideoMqHandler);
      } else if (mq.addListener) {
        mq.addListener(root._psVideoMqHandler);
      }
    }

    function initProductSpotlight(root) {
      if (!root) return;

      var mediaMode = root.dataset.psMediaMode || 'carousel';
      if (mediaMode === 'video') {
        if (root.dataset.psVideoInit === '1') return;
        initSpotlightVideo(root);
        return;
      }

      if (root.dataset.psSwiperInit === '1') return;

      var swiperEl = root.querySelector('[data-ps-swiper]');
      if (!swiperEl) return;

      var slides = swiperEl.querySelectorAll('.swiper-slide');
      var count = slides.length;
      if (!count) return;

      var prevEl = root.querySelector('.product-spotlight-v2__nav--prev');
      var nextEl = root.querySelector('.product-spotlight-v2__nav--next');
      var paginationEl = root.querySelector('[data-ps-pagination]');

      function run() {
        if (typeof window.Swiper === 'undefined') return;
        if (root.dataset.psSwiperInit === '1') return;
        root.dataset.psSwiperInit = '1';

        var opts = {
          slidesPerView: 1,
          speed: 400,
          watchOverflow: true,
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
        };

        if (paginationEl && count > 1) {
          opts.pagination = {
            el: paginationEl,
            clickable: true,
          };
        }

        root._psSwiper = new window.Swiper(swiperEl, opts);
      }

      function whenSwiperReady(cb) {
        if (typeof window.Swiper !== 'undefined') {
          cb();
          return;
        }
        if (typeof window.ensureSwiperLoaded === 'function') {
          window.ensureSwiperLoaded(cb);
          return;
        }
        var done = false;
        var poll = null;
        function finish() {
          if (done) return;
          if (typeof window.Swiper === 'undefined') return;
          done = true;
          document.removeEventListener('swiper-loaded', onLoaded);
          if (poll) clearInterval(poll);
          cb();
        }
        function onLoaded() {
          finish();
        }
        document.addEventListener('swiper-loaded', onLoaded);
        poll = setInterval(finish, 50);
        setTimeout(function () {
          if (poll) clearInterval(poll);
          document.removeEventListener('swiper-loaded', onLoaded);
        }, 8000);
      }

      whenSwiperReady(run);
    }

    function initAll() {
      document.querySelectorAll('.product-spotlight-v2').forEach(initProductSpotlight);
    }

    function scheduleInit() {
      function go() {
        initAll();
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function onDom() {
          document.removeEventListener('DOMContentLoaded', onDom);
          setTimeout(go, 0);
        });
      } else {
        setTimeout(go, 0);
      }
    }

    scheduleInit();
    document.addEventListener('swiper-loaded', initAll);

    document.addEventListener('shopify:section:load', function (ev) {
      var target = ev.target;
      if (!target || !target.querySelector) return;
      var el = target.classList.contains('product-spotlight-v2') ? target : target.querySelector('.product-spotlight-v2');
      if (el) {
        destroySpotlight(el);
        setTimeout(function () {
          initProductSpotlight(el);
        }, 0);
      }
    });

    document.addEventListener('shopify:section:unload', function (ev) {
      var target = ev.target;
      if (!target || !target.querySelector) return;
      var el = target.classList.contains('product-spotlight-v2') ? target : target.querySelector('.product-spotlight-v2');
      if (el) destroySpotlight(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
